import React, { useEffect, useState, useContext } from "react";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonDatePicker from "./CommonDatePicker";
import { toastWarn } from "../../common/Toast";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import { AppContext } from "../../context/AppContext";

function CommonDatePickerSelect({
  callbackStartDate,
  callbackEndDate,
  dateSelectValue
}) {
   const { dateFormate } = useContext(AppContext);
  const [beginningDate, setBeginningDate] = useState(moment().tz("America/New_York").toDate());
  const [finalDate, setFinalDate] = useState(moment().tz("America/New_York").toDate());
  const [dateSelectId, setDateSelectId] = useState(0);

// Today
let today = moment().tz("America/New_York").startOf('day').toDate();

// Week
const startOfWeek = moment().tz("America/New_York").startOf("week").toDate();
const endOfWeek = moment().tz("America/New_York").endOf("week").startOf('day').toDate();

// Last Week
const startOfLastWeek = moment().tz("America/New_York").subtract(1, 'week').startOf("week").toDate();
const endOfLastWeek = moment().tz("America/New_York").subtract(1, 'week').endOf("week").startOf('day').toDate();

// Last 7 Days
const startOfLast7Days = moment().tz("America/New_York").subtract(6, 'days').startOf('day').toDate();
const endOfLast7Days = today;

// This Month
const startOfMonth = moment().tz("America/New_York").startOf("month").toDate();
const endOfMonth = moment().tz("America/New_York").endOf("month").startOf('day').toDate();

// Last Month
const startOfLastMonth = moment()
  .tz("America/New_York")
  .subtract(1, "month")
  .startOf("month")
  .toDate();
const endOfLastMonth = moment()
  .tz("America/New_York")
  .subtract(1, "month")
  .endOf("month")
  .startOf('day')
  .toDate();

// This Year
const startOfYear = moment().tz("America/New_York").startOf("year").toDate();
const endOfYear = moment().tz("America/New_York").endOf("year").startOf('day').toDate();

// Last Year
const startOfLastYear = moment()
  .tz("America/New_York")
  .subtract(1, "year")
  .startOf("year")
  .toDate();
const endOfLastYear = moment()
  .tz("America/New_York")
  .subtract(1, "year")
  .endOf("year")
  .startOf('day')
  .toDate();

// Start date (one year ago from today)
const startDate365Day = moment()
  .tz("America/New_York")
  .subtract(1, 'years')
  .toDate();

// End date (today)
const endDate365Day = moment()
  .tz("America/New_York")
  .subtract(1,'day')
  .startOf('day')
  .toDate();


  const formatCallbackDate = (event) =>{
    return moment(event).format('YYYY-MM-DD');
  }

  const handleDateFilter = (event) => {
    // setShowDateFilterModal(true);
    setDateSelectId(event?.value);
  
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
      callbackStartDate(formatCallbackDate(today));
      callbackEndDate(formatCallbackDate(today));
  
    } else if (event?.value == 4) {
      console.log(endOfWeek, "checkDate321")
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
      callbackStartDate(formatCallbackDate(startOfWeek));
      callbackEndDate(formatCallbackDate(endOfWeek));
  
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
      callbackStartDate(formatCallbackDate(startOfMonth));
      callbackEndDate(formatCallbackDate(endOfMonth));
  
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
      callbackStartDate(formatCallbackDate(startOfLastMonth));
      callbackEndDate(formatCallbackDate(endOfLastMonth));
  
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
      callbackStartDate(formatCallbackDate(startOfYear));
      callbackEndDate(formatCallbackDate(endOfYear));
  
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
      callbackStartDate(formatCallbackDate(startOfLastYear));
      callbackEndDate(formatCallbackDate(endOfLastYear));
  
    } else if (event?.value == 8) {
      setBeginningDate(startDate365Day);
      setFinalDate(endDate365Day);
      callbackStartDate(formatCallbackDate(startDate365Day));
      callbackEndDate(formatCallbackDate(endDate365Day));
    } else if (event?.value == 9) {
      setBeginningDate(startOfLast7Days);
      setFinalDate(endOfLast7Days);
      callbackStartDate(formatCallbackDate(startOfLast7Days));
      callbackEndDate(formatCallbackDate(endOfLast7Days));
    }
  };
  
useEffect(()=>{
  handleDateFilter({value: dateSelectValue})
},[])
  //Date
  const handleDate = (event) => {
    setBeginningDate(event);
    setDateSelectId(7);
    // back to parent Component
    callbackStartDate(formatCallbackDate(event));
  };
  
  const handleEndDate = (event) => {
    setFinalDate(event);
    setDateSelectId(7);
    // back to parent Component
    callbackEndDate(formatCallbackDate(event))
  };

  const dateOptions = [
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "Last 7 Day", value: 9 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom (1 year)", value: 7 },
    { label: "All", value: 8 },
  ]

console.log(beginningDate, " => ", finalDate, "Daterange")

  return (
    <>
      <div className="col-md-2">
        {/* <div className="col-form-label">Date Picker:</div> */}
        Date Picker:
        <Select
          onChange={(event) => {
            handleDateFilter(event);
          }}
          placeholder="Select Date Range"
          options={dateOptions}
          value={dateOptions.find((el) => el?.value == dateSelectId)}
          backspaceRemovesValue={false}
          controlShouldRenderValue={true}
          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
          className="custom-search-select"
          hideSelectedOptions={true}
          // isClearable={true}
          // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
        />
      </div>
      <div className="col-md-2">
        {/* <div className="col-form-label">From:</div> */}
        <div>
        From:
        </div>
          <DatePicker
        selected={beginningDate}
        onChange={(date) => handleDate(date)}
        selectsStart
        startDate={beginningDate}
        endDate={finalDate}
        dateFormat={dateFormate}
        // dateFormat="MM/dd/yyyy"
        placeholderText="Choose Date"
        className="form-control form-control-sm datetimepicker"
      />
      </div>
      <div className="col-md-2">
        {/* <div className="col-form-label">To:</div> */}
        <div>
          To:
        </div>
         <DatePicker
        selected={finalDate}
        onChange={(date) => handleEndDate(date)}
        selectsEnd
        startDate={beginningDate}
        endDate={finalDate}
        minDate={beginningDate}
        maxDate={moment(beginningDate).add(1, 'years').tz("America/New_York").toDate()}
        dateFormat={dateFormate || "MM/dd/yyyy"}
        // dateFormat="MM/dd/yyyy"
        placeholderText="Choose Date"
        className="form-control form-control-sm datetimepicker"
      />
      </div>
    </>
  );
}

export default CommonDatePickerSelect;
